import React from 'react'
import type {GatsbyBrowser} from 'gatsby'
import './src/assets/scss/main.scss'
import Layout from './src/components/Layout'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => <Layout>{element}</Layout>
